<template>
  <Layout>
    <div class="page-header">
      <div class="page-title">
        <h2>{{$t('journeys_name')}} ({{this.programDetails.name}})</h2>
        <h5>{{$t('manage_journey')}}</h5>
      </div>

      <div class="actions">
        <TableDownload
            :data="tableData.data"
            :fields="['user.fullName','email', 'status', 'program', 'progress', 'createdAt']"
            :headers="{
              'user.fullName': $t('name'),
              'email': $t('e_mail'),
              'status': $t('status'),
              'program': 'Program',
              'progress': $t('progress_journeys'),
              'createdAt': $t('on_schedule')
            }"
            :computed-fields="{
              'status': (item) => item.status ? $t('ended') : $t('active'),
              'progress': (item) => (item.progress || 0) + '%',
              'createdAt': (item) => formatDate(item.createdAt)
            }"
            :filename="$t('journey_users_report')"
        />
        <JourneyUserFilters />
        <ExpandableSearch />
      </div>
    </div>

    <div class="table-holder">
            <JourneyUserTable :users="tableData.data" :refresh-data="() => {
              handlePage(currentPage);
            }" :loading="isLoading" />

      <div class="pagination-align-center">
        <Pagination :total-items="tableData.total" :per-page="20" :current-page="currentPage" :on-page-change="handlePage"/>
      </div>
    </div>
  </Layout>
</template>

<script>
import BarChart from '@/components/charts/BarChart.vue'
import Layout from "@/components/layouts/Layout.vue";
import AvatarArray from "@/components/AvatarArray.vue";
import Pagination from "@/components/Pagination.vue";
import JourneyUserTable from "@/components/tables/Journey/JourneyUserTable.vue";
import UserTable from "@/components/tables/User/UserTable.vue";
import journeyService from "@/service/journeyService";
import {handleErrorResponse} from "@/utils/utils";
import ExpandableSearch from "@/components/ExpandableSearch.vue";
import JourneyUserFilters from "@/components/tables/Journey/JourneyUserFilters.vue";
import JourneyProgramTable from "@/components/tables/Journey/JourneyProgramTable.vue";
import programService from "@/service/programService";
import chatSocket from "@/utils/chatSocket";
import users from "@/pages/Users.vue";
import TableDownload from "@/components/TableDownload.vue";

export default {
  name: 'JourneyPrograms',
  computed: {
    users() {
      return users
    }
  },
  components: {
    TableDownload,
    JourneyProgramTable,
    JourneyUserFilters,
    ExpandableSearch,
    UserTable,
    JourneyUserTable,
    Pagination,
    AvatarArray,
    Layout,
    BarChart,
  },
  data() {
    return {
      programDetails:{},
      isLoading: true,
      data: {},
      tableData: {
        data: [],
        total: 0
      },
      currentPage: 1,
    }
  },
  watch: {
    $route() {
      this.handlePage(1);
    }
  },

  created() {
    this.getProgramDetails();
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    },
    getProgramDetails(){
      const routeParams = this.$route.params;
      programService.getProgramDetail(routeParams.id).then((res) => {
        this.programDetails = res.data.data;
      })
    },
    handlePage(page) {
      const routeParams = this.$route.params;
      if (this.isLoading && this.currentPage !== 1) return;

      this.isLoading = true;
      this.currentPage = page;

      const routeQuery = this.$route.query;
      const tempFilters = [];

      if (routeQuery.searchText) {
        tempFilters.push({
          key: 'searchText',
          value: routeQuery.searchText
        });
      }

      if (routeQuery.addedDate) {
        tempFilters.push({
          key: 'addedDate',
          value: routeQuery.addedDate
        });
      }

      if (routeQuery.addedDateEnd) {
        tempFilters.push({
          key: 'addedDateEnd',
          value: routeQuery.addedDateEnd
        });
      }

      if (routeQuery.status) {
        if(routeQuery.status === "0") {
          tempFilters.push({
            key: 'status',
            value: "0"

          })}
        else if(routeQuery.status==="1"){
          tempFilters.push({
            key: 'status',
            value: "1"
          })
        } else if(routeQuery.status==="2"){
          tempFilters.push({
            key: 'status',
            value: "2"
          })
        } else if(routeQuery.status==="3"){
          tempFilters.push({
            key: 'status',
            value: "3"
          })
        }
      }

      journeyService.getJourneyFromProgram(page,routeParams.id, tempFilters).then((res) => {
        this.tableData = res.data.data;
        this.isLoading = false;
      }).catch((err) => {
        handleErrorResponse(error, this.$snackbar);
      });
    }

  }
}
</script>

<style scoped>
.icon-title span {
  font-family: 'euclid_medium', sans-serif;
  font-size: 18px;
  white-space: nowrap
}

.icon-holder img {
  cursor: default;
}

.table-title {
  font-family: 'euclid_medium', sans-serif;
  color: #040C2D;
  position: sticky;
  background: white;
}

.table-holder {
  margin-top:20px;
}

</style>
